export enum ViewBy {
  cpo = 'CPO',
  roas = 'ROAS'
}

export enum ViewByStrings {
  ROAS = 'ROAS',
  CPO = 'CPO'
}
